import loginedApi from "../apis";
import { FETCH_APPOINTMENT_HISTORY, FETCH_SELECTED_APPOINTMENT_DETAILS } from "./type";
import specialist from "../specialityList";
import authHeader from './auth-header';
import CryptoJS from "crypto-js";
  var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

const publicIp = require("public-ip");
let IP = publicIp.v4();
const { detect } = require('detect-browser');
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`



export const updatereports = (formdata) => async (dispatch) => {

    let resp = await loginedApi.post("getcountrycode", 
    {
      token :hashcode.toString(),
      "version":"2.0",
      "data": {"browserTimeZone":"GMT%2B05:30"},
      "requestType": 1058
  });
  const doctorscountrycode = resp.data.data;


    const res = await loginedApi.post("updatereports",formdata ,{ headers: authHeader() });

    console.log("updatereports",res);


    if (res.status === 200) {
        
        dispatch({
            type: FETCH_APPOINTMENT_HISTORY,
            payload: res.data.data,
        });
        return res

    }
};

export const uploadreportfromhistory = ({appointmentId,filename}) => async (dispatch) => {

  let resp = await loginedApi.post("getcountrycode", 
  {
    token :hashcode.toString(),
    "version":"2.0",
    "data": {"browserTimeZone":"GMT%2B05:30"},
    "requestType": 1058
});
const doctorscountrycode = resp.data.data;

console.log("appointmentId",appointmentId,"filename",filename)

const res = await loginedApi.post("uploadreportfromhistory",
        {
            "requestType": "530",
            token :hashcode.toString(),
            "version":"2.0",
            "data": {
                appointmentId: appointmentId,
                filename: filename,
                browserTimeZone: `GMT${formatTime}`,
                "source": "Patient",
                
                Browser: browser.name+" "+browser.version,
                appname: "C2MD Web",
                Ipaddress: doctorscountrycode.Ipaddress, 
                useragent: userAgent,
            }
        }
    );

  //const res = await loginedApi.post("updatereports",formdata ,{ headers: authHeader() });

  console.log("updatereports",res);


  if (res.status === 200) {
      
      
      return res

  }
};

